import React from 'react'
import { useParams } from 'react-router-dom'
import Container from 'react-bootstrap/Container'

import AppointmentPanel from '../components/presentations/appointment/AppointmentPanel'

/**
 * Where a texted or emailed {CONFIRM_LINK} lands (US-37724).
 *
 * Reached with no session at all — the guest token in `?token=` is picked up by
 * useStorageApp and is the only credential. That token is scoped to this one event and
 * expires, unlike every other portal link the platform issues.
 *
 * The page is deliberately just the panel. A client following "confirm your appointment" has
 * one decision to make, and burying it in a document view is how it gets missed.
 */
const AppointmentDetail = () => {
  const { id } = useParams()

  return (
    <Container className='mx-auto appointment-page'>
      <AppointmentPanel eventId={id} />
    </Container>
  )
}

export default AppointmentDetail
